var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CPagination',{attrs:{"active-page":_vm.lPage,"pages":Math.ceil(_vm.total/_vm.size),"align":"end"},on:{"update:activePage":function($event){_vm.lPage=$event},"update:active-page":function($event){_vm.lPage=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }